import React from "react";
import kbLogo from "../../Assets/kb-logo.png"
import "./Logo.css"

const Logo = () => {
    return(
        <>
            <img src= { kbLogo } alt="Kostbar Logo" />
        </>
    )
}



export default Logo